import { FormicaSelectBoxItem } from '../components/custom/FormicaSearchSelectBox';
import { EventTrackerPlatform } from '../domain/tracker/Tracker';
import { TrackerVariableTypeMobile, TrackerVariableTypeWeb } from '../domain/tracker/TrackerVariableType';
import { TrackerTriggerTypeMobile, TrackerTriggerTypeWeb } from '../domain/tracker/TrackerTriggerType';
import DataType from '../constant/DataType';
import TrackerFilterOperator from 'domain/tracker/filter/TrackerFilterOperator';
import TrackerVariable, {
  TrackerChargingTypeVariable,
  TrackerClickOnlyPatternVariable,
  TrackerCookieVariable,
  TrackerCustomEventVariable,
  TrackerElementVariable,
  TrackerEnvironmentChangeFlagsVariable,
  TrackerEnvironmentChangeScoreVariable,
  TrackerEventVariable,
  TrackerFastPageTransitionVariable,
  TrackerFormFillAnomalyVariable,
  TrackerFormFillDurationMsVariable, TrackerHeadlessIndicatorCountVariable,
  TrackerInputPasteRatioVariable,
  TrackerJavascriptVariable,
  TrackerNavigationVelocityVariable,
  TrackerNoMouseMoveDurationMsVariable,
  TrackerRemoteAccessFlagsJsonVariable,
  TrackerRemoteAccessScoreVariable, TrackerScreenResolutionVariable,
  TrackerThemeModeVariable,
  TrackerUrlVariable,
  TrackerUserAgentVariable,
} from '../domain/tracker/variable/TrackerVariable';

class TrackerTypeUtil {
  public static getVariableTypeOptions(platform: EventTrackerPlatform): FormicaSelectBoxItem[] {
    if (platform == EventTrackerPlatform.MOBILE) {
      return [
        {
          label: TrackerVariableTypeMobile.IS_SIMULATOR,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_SIMULATOR,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-is-simulator',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.DEVICE_MODEL,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.DEVICE_MODEL,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-device-model',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.RAM_SIZE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.RAM_SIZE,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-ram-size',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.APP_STATE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.APP_STATE,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-app-state',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.ARCH,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.ARCH,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-arch',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.BATTERY_LEVEL,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.BATTERY_LEVEL,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-battery-level',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.BRIGHTNESS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.BRIGHTNESS,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-brightness',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.IS_PHONE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_PHONE,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-is-phone',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.IS_TABLET,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_TABLET,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-is-tablet',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.LANGUAGE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.LANGUAGE,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-language-settings',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.REGION,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.REGION,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-region',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.ORIENTATION,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.ORIENTATION,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-orientation',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.RESOLUTION_HEIGHT,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.RESOLUTION_HEIGHT,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-resolution-height',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.RESOLUTION_WIDTH,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.RESOLUTION_WIDTH,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-resolution-width',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.UNIQUE_DEVICE_ID,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.UNIQUE_DEVICE_ID,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-unique-device-id',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.TIME_ZONE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.TIME_ZONE,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-time-zone',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.REACHABLE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.REACHABLE,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-reachable',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.MAC_ADDRESS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.MAC_ADDRESS,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-mac-address',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.NETWORK_TYPE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.NETWORK_TYPE,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-network-type',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.WIFI_SSID,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.WIFI_SSID,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-ip-address',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.IP_ADDRESS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IP_ADDRESS,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-ip-address',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.IS_VPN,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_VPN,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-ip-address',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CUSTOM_TRIGGER_ARGS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CUSTOM_TRIGGER_ARGS,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-custom-trigger',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CALL_DURATION,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CALL_DURATION,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-call-duration',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CALL_IS_INCOMING,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CALL_IS_INCOMING,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-call-is-incoming',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CALL_NUMBER,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CALL_NUMBER,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-call-number',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.IS_IN_VOIP_CALL,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_IN_VOIP_CALL,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-call-number',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.IS_IN_CALL,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_IN_CALL,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-call-number',

          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.IS_ROOTED,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_ROOTED,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-is-rooted',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.SCREEN_RECORD_DURATION,
          value: {
            name: '',
            type: TrackerVariableTypeMobile.SCREEN_RECORD_DURATION,
            properties: { dataType: DataType.NUMBER },
            description: '',
            icon: 'tracker-screen-record-duration',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.SCREEN_RECORD_STATUS,
          value: {
            name: '',
            type: TrackerVariableTypeMobile.SCREEN_RECORD_STATUS,
            properties: { dataType: DataType.STRING },
            description: '',
            icon: 'tracker-screen-record-duration',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.LAST_KNOWN_LON,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.LAST_KNOWN_LON,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-last-known-lon',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.LAST_KNOWN_LAT,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.LAST_KNOWN_LAT,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-last-known-lat',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.TILT_STATUS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.TILT_STATUS,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-tilt-status',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CURRENT_TRIGGER_NAME,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CURRENT_TRIGGER_NAME,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-current-trigger-name',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.PLATFORM,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.PLATFORM,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-platform',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.GYRO_X,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.GYRO_X,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-gyro-x',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.GYRO_Y,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.GYRO_Y,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-gyro-y',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.GYRO_Z,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.GYRO_Z,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-gyro-z',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.SCREEN_SHARE_DURATION,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.SCREEN_SHARE_DURATION,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-screen-share-duration',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.SCREEN_SHARE_STATUS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.SCREEN_SHARE_STATUS,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-screen-share-status',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CONTACT_LIST,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CONTACT_LIST,
            properties: { dataType: DataType.ARRAY },
            icon: 'tracker-contact-list',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.IS_CONTACT,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_CONTACT,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-contact-list',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.APP_LIST,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.APP_LIST,
            properties: { dataType: DataType.ARRAY },
            icon: 'tracker-app-list',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CHARGING_TYPE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CHARGING_TYPE,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-chargingtype',
            chargingType: 'UNKNOWN',
          } as TrackerChargingTypeVariable,
        },
        {
          label: TrackerVariableTypeMobile.THEME_MODE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.THEME_MODE,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-thememode',
            themeMode: 'UNKNOWN',
          } as TrackerThemeModeVariable,
        },
        {
          label: TrackerVariableTypeMobile.IS_CHARGING,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_CHARGING,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-ischarging',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.APP_SIGNATURE_HASH,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.APP_SIGNATURE_HASH,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-appsignaturehash',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.SIM_SERIAL_HASH,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.SIM_SERIAL_HASH,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-simserialhash',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.IS_DEBUGGER_ATTACHED,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_DEBUGGER_ATTACHED,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-isdebuggerattached',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.REMOTE_SESSION_STATUS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.REMOTE_SESSION_STATUS,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-remotesessionstatus',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.RUNTIME_TAMPERED,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.RUNTIME_TAMPERED,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-runtimetampered',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.SDK_VERSION,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.SDK_VERSION,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-sdkversion',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.TIMESTAMP,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.TIMESTAMP,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-timestamp',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.COUNTRY,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.COUNTRY,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-country',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.ANDROID_ID,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.ANDROID_ID,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-androidid',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CDID,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CDID,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-cdid',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.NODE_NAME,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.NODE_NAME,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-nodename',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.OS_VERSION,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.OS_VERSION,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-osversion',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.PHONE_RADIO_VERSION,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.PHONE_RADIO_VERSION,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-phoneradioversion',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.PHONE_HOST,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.PHONE_HOST,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-phonehost',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.HAS_X86_ABI,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.HAS_X86_ABI,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-hasx86abi',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.STAGEFRIGHT_VULNERABLE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.STAGEFRIGHT_VULNERABLE,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-stagefrightvulnerable',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.ADB_ENABLED,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.ADB_ENABLED,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-adbenabled',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.SELINUX_STATUS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.SELINUX_STATUS,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-selinuxstatus',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.REMOTE_CONTROL_ACTIVE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.REMOTE_CONTROL_ACTIVE,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-remotecontrolactive',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.EMULATOR_FAMILY,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.EMULATOR_FAMILY,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-emulatorfamily',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.FRIDA_DETECTED,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.FRIDA_DETECTED,
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-fridadetected',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CARRIER,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CARRIER,
            properties: { dataType: DataType.STRING },
            icon: 'tracker-carrier',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.ELAPSED_TIME,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.ELAPSED_TIME,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-elapsed-time',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.GPS_ACCURACY_HORIZONTAL,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.GPS_ACCURACY_HORIZONTAL,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-gps-accuracy-horizontal',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.GPS_ACCURACY_VERTICAL,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.GPS_ACCURACY_VERTICAL,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-gps-accuracy-vertical',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.GPS_ALTITUDE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.GPS_ALTITUDE,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-gps-altitude',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.GPS_BEARING,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.GPS_BEARING,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-gps-bearing',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.GPS_SPEED,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.GPS_SPEED,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-gps-speed',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.GPS_PROVIDER,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.GPS_PROVIDER,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-gps-provider',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.WIFI_BSSID,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.WIFI_BSSID,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-wifi-bssid',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.WIFI_CHANNEL,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.WIFI_CHANNEL,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-wifi-channel',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.WIFI_FREQUENCY,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.WIFI_FREQUENCY,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-wifi-frequency',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.WIFI_SIGNAL_STRENGTH,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.WIFI_SIGNAL_STRENGTH,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-wifi-signal-strength',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CELL_ID,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CELL_ID,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-cell-id',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CELL_LAC,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CELL_LAC,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-cell-lac',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CELL_SIGNAL_STRENGTH,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CELL_SIGNAL_STRENGTH,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-cell-signal-strength',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CELL_NETWORK_TYPE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CELL_NETWORK_TYPE,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-cell-network-type',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.HAS_ESIM_SUPPORT,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.HAS_ESIM_SUPPORT,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-has-esim-support',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.IS_USING_ESIM,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_USING_ESIM,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-is-using-esim',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.SIM_SLOT_COUNT,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.SIM_SLOT_COUNT,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-sim-slot-count',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.ACTIVE_SUBSCRIPTION_COUNT,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.ACTIVE_SUBSCRIPTION_COUNT,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-active-subscription-count',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.IS_OVERLAY_DETECTED,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.IS_OVERLAY_DETECTED,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-is-overlay-detected',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.CAN_DRAW_OVERLAYS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.CAN_DRAW_OVERLAYS,
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-can-draw-overlays',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.BEHAVIORAL_BIOMETRIC_SCORE,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.BEHAVIORAL_BIOMETRIC_SCORE,
            properties: { dataType: DataType.NUMBER },
            icon: 'behavioral-biometric-score',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.BEHAVIORAL_BIOMETRIC_FLAGS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.BEHAVIORAL_BIOMETRIC_FLAGS,
            properties: { dataType: DataType.ARRAY, itemType: DataType.STRING },
            icon: 'behavioral-biometric-flags',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.SCROLL_BEHAVIOR,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.SCROLL_BEHAVIOR,
            properties: { dataType: DataType.OBJECT },
            icon: 'scroll-behavior',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.SESSION_BEHAVIOR,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.SESSION_BEHAVIOR,
            properties: { dataType: DataType.OBJECT },
            icon: 'session-behavior',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.SWIPE_DYNAMICS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.SWIPE_DYNAMICS,
            properties: { dataType: DataType.OBJECT },
            icon: 'swipe-dynamics',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeMobile.TOUCH_DYNAMICS,
          value: {
            name: '',
            description: '',
            type: TrackerVariableTypeMobile.TOUCH_DYNAMICS,
            properties: { dataType: DataType.OBJECT },
            icon: 'touch-dynamics',
          } as TrackerVariable,
        },
      ];
    } else {
      return [
        {
          label: TrackerVariableTypeWeb.URL,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'tracker-url',
            selection: 'full',
            type: TrackerVariableTypeWeb.URL,
            description: '',
          } as TrackerUrlVariable,
        },
        {
          label: TrackerVariableTypeWeb.ELEMENT,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'tracker-element',
            type: TrackerVariableTypeWeb.ELEMENT,
            option: { cssSelector: '', attribute: '' },
            description: '',
          } as TrackerElementVariable,
        },
        {
          label: TrackerVariableTypeWeb.COOKIE,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'tracker-cookie',
            type: TrackerVariableTypeWeb.COOKIE,
            description: '',
            cookieName: '',
            decodeUrlCookie: false,
          } as TrackerCookieVariable,
        },
        {
          label: TrackerVariableTypeWeb.JAVASCRIPT,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'tracker-java-script',
            type: TrackerVariableTypeWeb.JAVASCRIPT,
            description: '',
            code: '',
          } as TrackerJavascriptVariable,
        },
        {
          label: TrackerVariableTypeWeb.EVENT,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'tracker-event',
            type: TrackerVariableTypeWeb.EVENT,
            selection: { cssSelector: '', attribute: '' },
            description: '',
          } as TrackerEventVariable,
        },
        {
          label: TrackerVariableTypeWeb.CUSTOM,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'tracker-custom',
            type: TrackerVariableTypeWeb.CUSTOM,
            description: '',
          } as TrackerCustomEventVariable,
        },
        {
          label: TrackerVariableTypeWeb.IP_ADDRESS,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'tracker-ip-address',
            type: TrackerVariableTypeWeb.IP_ADDRESS,
            description: '',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeWeb.DEVICE_FINGERPRINT,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'device-fingerprint',
            type: TrackerVariableTypeWeb.DEVICE_FINGERPRINT,
            description: '',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeWeb.SUSPICIOUS_ACTIVITY,
          value: {
            name: '',
            properties: { dataType: DataType.NUMBER },
            icon: 'suspicious-activity',
            type: TrackerVariableTypeWeb.SUSPICIOUS_ACTIVITY,
            description: '',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeWeb.SUSPICIOUS_BROWSER,
          value: {
            name: '',
            properties: { dataType: DataType.BOOLEAN },
            icon: 'suspicious-browser',
            type: TrackerVariableTypeWeb.SUSPICIOUS_BROWSER,
            description: '',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeWeb.LANGUAGE,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'tracker-language-settings',
            type: TrackerVariableTypeWeb.LANGUAGE,
            description: '',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeWeb.TIMEZONE,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'tracker-time-zone',
            type: TrackerVariableTypeWeb.TIMEZONE,
            description: '',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeWeb.OS,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'os',
            type: TrackerVariableTypeWeb.OS,
            description: '',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeWeb.BROWSER,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'browser',
            type: TrackerVariableTypeWeb.BROWSER,
            description: '',
          } as TrackerVariable,
        },
        {
          label: TrackerVariableTypeWeb.SCREEN_RESOLUTION,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'tracker-screenresolution',
            type: TrackerVariableTypeWeb.SCREEN_RESOLUTION,
            description: '',
          } as TrackerScreenResolutionVariable,
        },
        {
          label: TrackerVariableTypeWeb.USER_AGENT,
          value: {
            name: '',
            properties: { dataType: DataType.STRING },
            icon: 'tracker-useragent',
            type: TrackerVariableTypeWeb.USER_AGENT,
            description: '',
          } as TrackerUserAgentVariable,
        },
        {
          label: TrackerVariableTypeWeb.REMOTE_ACCESS_SCORE,
          value: {
            name: '',
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-remoteaccess',
            type: TrackerVariableTypeWeb.REMOTE_ACCESS_SCORE,
            description: '',
          } as TrackerRemoteAccessScoreVariable,
        },
        {
          label: TrackerVariableTypeWeb.REMOTE_ACCESS_FLAGS_JSON,
          value: {
            name: '',
            properties: { dataType: DataType.OBJECT },
            icon: 'tracker-remoteaccessflagsjson',
            type: TrackerVariableTypeWeb.REMOTE_ACCESS_FLAGS_JSON,
            description: '',
          } as TrackerRemoteAccessFlagsJsonVariable,
        },
        {
          label: TrackerVariableTypeWeb.ENVIRONMENT_CHANGE_FLAGS,
          value: {
            name: '',
            properties: { dataType: DataType.OBJECT },
            icon: 'tracker-environmentchangeflags',
            type: TrackerVariableTypeWeb.ENVIRONMENT_CHANGE_FLAGS,
            description: '',
          } as TrackerEnvironmentChangeFlagsVariable,
        },
        {
          label: TrackerVariableTypeWeb.ENVIRONMENT_CHANGE_SCORE,
          value: {
            name: '',
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-environmentchangescore',
            type: TrackerVariableTypeWeb.ENVIRONMENT_CHANGE_SCORE,
            description: '',
          } as TrackerEnvironmentChangeScoreVariable,
        },
        {
          label: TrackerVariableTypeWeb.NO_MOUSE_MOVE_DURATION_MS,
          value: {
            name: '',
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-nomousemoveduration',
            type: TrackerVariableTypeWeb.NO_MOUSE_MOVE_DURATION_MS,
            description: '',
          } as TrackerNoMouseMoveDurationMsVariable,
        },
        {
          label: TrackerVariableTypeWeb.CLICK_ONLY_PATTERN,
          value: {
            name: '',
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-clickonlypattern',
            type: TrackerVariableTypeWeb.CLICK_ONLY_PATTERN,
            description: '',
          } as TrackerClickOnlyPatternVariable,
        },
        {
          label: TrackerVariableTypeWeb.FAST_PAGE_TRANSITION,
          value: {
            name: '',
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-fastpagetransition',
            type: TrackerVariableTypeWeb.FAST_PAGE_TRANSITION,
            description: '',
          } as TrackerFastPageTransitionVariable,
        },
        {
          label: TrackerVariableTypeWeb.FORM_FILL_ANOMALY,
          value: {
            name: '',
            properties: { dataType: DataType.BOOLEAN },
            icon: 'tracker-formfillanomaly',
            type: TrackerVariableTypeWeb.FORM_FILL_ANOMALY,
            description: '',
          } as TrackerFormFillAnomalyVariable,
        },
        {
          label: TrackerVariableTypeWeb.FORM_FILL_DURATION_MS,
          value: {
            name: '',
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-formfillduration',
            type: TrackerVariableTypeWeb.FORM_FILL_DURATION_MS,
            description: '',
          } as TrackerFormFillDurationMsVariable,
        },
        {
          label: TrackerVariableTypeWeb.NAVIGATION_VELOCITY,
          value: {
            name: '',
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-navigationvelocity',
            type: TrackerVariableTypeWeb.NAVIGATION_VELOCITY,
            description: '',
          } as TrackerNavigationVelocityVariable,
        },
        {
          label: TrackerVariableTypeWeb.INPUT_PASTE_RATIO,
          value: {
            name: '',
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-inputpasteratio',
            type: TrackerVariableTypeWeb.INPUT_PASTE_RATIO,
            description: '',
          } as TrackerInputPasteRatioVariable,
        },
        {
          label: TrackerVariableTypeWeb.HEADLESS_INDICATOR_COUNT,
          value: {
            name: '',
            properties: { dataType: DataType.NUMBER },
            icon: 'tracker-headlessindicator',
            type: TrackerVariableTypeWeb.HEADLESS_INDICATOR_COUNT,
            description: '',
          } as TrackerHeadlessIndicatorCountVariable,
        },
      ];
    }
  }

  public static getEventTypeOptions(platform: EventTrackerPlatform): FormicaSelectBoxItem[] {
    if (platform == EventTrackerPlatform.MOBILE) {
      return [
        {
          label: TrackerTriggerTypeMobile.APP_STATE_CHANGE,
          value: { name: TrackerTriggerTypeMobile.APP_STATE_CHANGE, icon: 'tracker-app-state-change' },
        },
        {
          label: TrackerTriggerTypeMobile.APP_CALL_END,
          value: { name: TrackerTriggerTypeMobile.APP_CALL_END, icon: 'tracker-app-call-end' },
        },
        {
          label: TrackerTriggerTypeMobile.APP_CALL_RING,
          value: { name: TrackerTriggerTypeMobile.APP_CALL_RING, icon: 'tracker-app-call-ring' },
        },
        {
          label: TrackerTriggerTypeMobile.APP_CALL_REJECT,
          value: { name: TrackerTriggerTypeMobile.APP_CALL_REJECT, icon: 'tracker-app-call-reject' },
        },
        {
          label: TrackerTriggerTypeMobile.APP_CALL_APPROVE,
          value: { name: TrackerTriggerTypeMobile.APP_CALL_APPROVE, icon: 'tracker-app-call-approve' },
        },
        {
          label: TrackerTriggerTypeMobile.VOIP_CALL_START,
          value: { name: TrackerTriggerTypeMobile.VOIP_CALL_START, icon: 'tracker-app-call-approve' },
        },
        {
          label: TrackerTriggerTypeMobile.VOIP_CALL_END,
          value: { name: TrackerTriggerTypeMobile.VOIP_CALL_END, icon: 'tracker-app-call-end' },
        },
        {
          label: TrackerTriggerTypeMobile.SCREEN_RECORD_START,
          value: { name: TrackerTriggerTypeMobile.SCREEN_RECORD_START, icon: 'tracker-screen-record-start' },
        },
        {
          label: TrackerTriggerTypeMobile.SCREEN_RECORD_END,
          value: { name: TrackerTriggerTypeMobile.SCREEN_RECORD_END, icon: 'tracker-screen-record-end' },
        },
        {
          label: TrackerTriggerTypeMobile.SCREEN_SHARE_START,
          value: { name: TrackerTriggerTypeMobile.SCREEN_SHARE_START, icon: 'tracker-screen-record-start' },
        },
        {
          label: TrackerTriggerTypeMobile.SCREEN_SHARE_END,
          value: { name: TrackerTriggerTypeMobile.SCREEN_SHARE_END, icon: 'tracker-screen-record-end' },
        },
        {
          label: TrackerTriggerTypeMobile.CUSTOM,
          value: { name: TrackerTriggerTypeMobile.CUSTOM, icon: 'tracker-custom-trigger' },
        },
        {
          label: TrackerTriggerTypeMobile.APPLICATION_OPEN,
          value: { name: TrackerTriggerTypeMobile.APPLICATION_OPEN, icon: 'tracker-application-open' },
        },
        {
          label: TrackerTriggerTypeMobile.NETWORK_CHANGE,
          value: { name: TrackerTriggerTypeMobile.NETWORK_CHANGE, icon: 'tracker-network-change' },
        },
        {
          label: TrackerTriggerTypeMobile.THEME_CHANGE,
          value: { name: TrackerTriggerTypeMobile.THEME_CHANGE, icon: 'tracker-themechange' },
        },
        {
          label: TrackerTriggerTypeMobile.CHARGING_STATE_CHANGE,
          value: { name: TrackerTriggerTypeMobile.CHARGING_STATE_CHANGE, icon: 'tracker-chargingstatechange' },
        },
        {
          label: TrackerTriggerTypeMobile.DEBUGGER_ATTACHED,
          value: { name: TrackerTriggerTypeMobile.DEBUGGER_ATTACHED, icon: 'tracker-debuggerattached' },
        },
        {
          label: TrackerTriggerTypeMobile.DEBUGGER_DETACHED,
          value: { name: TrackerTriggerTypeMobile.DEBUGGER_DETACHED, icon: 'tracker-debuggerdetached' },
        },
        {
          label: TrackerTriggerTypeMobile.SIM_CARD_CHANGE,
          value: { name: TrackerTriggerTypeMobile.SIM_CARD_CHANGE, icon: 'tracker-simcardchange' },
        },
        {
          label: TrackerTriggerTypeMobile.TAMPER_DETECTED,
          value: { name: TrackerTriggerTypeMobile.TAMPER_DETECTED, icon: 'tracker-tamperdetected' },
        },
        {
          label: TrackerTriggerTypeMobile.SDK_VERSION,
          value: { name: TrackerTriggerTypeMobile.SDK_VERSION, icon: 'tracker-sdkVersion' },
        },
        {
          label: TrackerTriggerTypeMobile.TIMESTAMP,
          value: { name: TrackerTriggerTypeMobile.TIMESTAMP, icon: 'tracker-timestamp' },
        },
        {
          label: TrackerTriggerTypeMobile.SCREENSHOT_TAKEN,
          value: { name: TrackerTriggerTypeMobile.SCREENSHOT_TAKEN, icon: 'tracker-screenshot-taken' },
        },
        {
          label: TrackerTriggerTypeMobile.OVERLAY_DETECTED,
          value: { name: TrackerTriggerTypeMobile.OVERLAY_DETECTED, icon: 'tracker-overlay-detected' },
        },
        {
          label: TrackerTriggerTypeMobile.BEHAVIORAL_VERIFIED,
          value: { name: TrackerTriggerTypeMobile.BEHAVIORAL_VERIFIED, icon: 'behavioral-verified' },
        },
        {
          label: TrackerTriggerTypeMobile.BEHAVIORAL_ANOMALY_DETECTED,
          value: { name: TrackerTriggerTypeMobile.BEHAVIORAL_ANOMALY_DETECTED, icon: 'behavioral-anomally-detected' },
        },
      ];
    } else {
      return [
        {
          label: TrackerTriggerTypeWeb.CLICK,
          value: { name: TrackerTriggerTypeWeb.CLICK, icon: 'tracker-click' },
        },
        {
          label: TrackerTriggerTypeWeb.PAGE_VIEW,
          value: { name: TrackerTriggerTypeWeb.PAGE_VIEW, icon: 'tracker-navigation' },
        },
        {
          label: TrackerTriggerTypeWeb.CUSTOM,
          value: { name: TrackerTriggerTypeWeb.CUSTOM, icon: 'tracker-custom' },
        },
        {
          label: TrackerTriggerTypeWeb.RISK_ALERT,
          value: { name: TrackerTriggerTypeWeb.RISK_ALERT, icon: 'tracker-riskalert' },
        },
        {
          label: TrackerTriggerTypeWeb.SDK_VERSION,
          value: {name: TrackerTriggerTypeWeb.SDK_VERSION, icon: 'tracker-sdkVersion'},
        },
        {
          label: TrackerTriggerTypeWeb.TIMESTAMP,
          value: {name: TrackerTriggerTypeWeb.TIMESTAMP, icon: 'tracker-timestamp'},
        }
      ];
    }
  }

  public static getFilterOptions = (dataType: DataType): FormicaSelectBoxItem[] => {
    switch (dataType) {
      case DataType.STRING:
        return [
          { label: 'Equals', value: TrackerFilterOperator.IS_EQUALS },
          { label: 'Equals Ignore Case', value: TrackerFilterOperator.IS_EQUALS_IGNORE_CASE },
          { label: 'Not Equals', value: TrackerFilterOperator.NOT_EQUALS },
          { label: 'Not Equals Ignore Case', value: TrackerFilterOperator.NOT_EQUALS_IGNORE_CASE },
          { label: 'Contains', value: TrackerFilterOperator.IS_CONTAINS },
          { label: 'Contains Ignore Case', value: TrackerFilterOperator.IS_CONTAINS_IGNORE_CASE },
          { label: 'Not Contains', value: TrackerFilterOperator.NOT_CONTAINS },
          { label: 'Not Contains Ignore Case', value: TrackerFilterOperator.NOT_CONTAINS_IGNORE_CASE },
          { label: 'Starts With', value: TrackerFilterOperator.IS_STARTS_WITH },
          { label: 'Starts With Ignore Case', value: TrackerFilterOperator.IS_STARTS_WITH_IGNORE_CASE },
          { label: 'Not Starts With', value: TrackerFilterOperator.NOT_STARTS_WITH },
          { label: 'Not Starts With Ignore Case', value: TrackerFilterOperator.NOT_STARTS_WITH_IGNORE_CASE },
          { label: 'Ends With', value: TrackerFilterOperator.IS_ENDS_WITH },
          { label: 'Ends With Ignore Case', value: TrackerFilterOperator.IS_ENDS_WITH_IGNORE_CASE },
          { label: 'Not Ends With', value: TrackerFilterOperator.NOT_ENDS_WITH },
          { label: 'Not Ends With Ignore Case', value: TrackerFilterOperator.NOT_ENDS_WITH_IGNORE_CASE },
          { label: 'Regex Match', value: TrackerFilterOperator.IS_REGEX_MATCH },
          { label: 'Regex Match Ignore Case', value: TrackerFilterOperator.IS_REGEX_MATCH_IGNORE_CASE },
          { label: 'Not Regex Match', value: TrackerFilterOperator.NOT_REGEX_MATCH },
          { label: 'Not Regex Match Ignore Case', value: TrackerFilterOperator.NOT_REGEX_MATCH_IGNORE_CASE },
        ];
      case DataType.NUMBER:
        return [
          { label: 'Equals', value: TrackerFilterOperator.IS_EQUALS },
          { label: 'Not Equals', value: TrackerFilterOperator.NOT_EQUALS },
          { label: 'Less Than', value: TrackerFilterOperator.LESS_THAN },
          { label: 'Less Than Or Equals', value: TrackerFilterOperator.LESS_THAN_OR_EQUALS },
          { label: 'Greater Than', value: TrackerFilterOperator.GREATER_THAN },
          { label: 'Greater Than Or Equals', value: TrackerFilterOperator.GREATER_THAN_OR_EQUALS },
        ];
      case DataType.BOOLEAN:
        return [
          { label: 'Equals', value: TrackerFilterOperator.IS_EQUALS },
          { label: 'Not Equals', value: TrackerFilterOperator.NOT_EQUALS },
        ];
      case DataType.DATE:
        return [
          { label: 'Equals', value: TrackerFilterOperator.IS_EQUALS },
          { label: 'Not Equals', value: TrackerFilterOperator.NOT_EQUALS },
          { label: 'Less Than', value: TrackerFilterOperator.LESS_THAN },
          { label: 'Less Than Or Equals', value: TrackerFilterOperator.LESS_THAN_OR_EQUALS },
          { label: 'Greater Than', value: TrackerFilterOperator.GREATER_THAN },
          { label: 'Greater Than Or Equals', value: TrackerFilterOperator.GREATER_THAN_OR_EQUALS },
        ];
      default:
        return [];
    }
  };
}

export default TrackerTypeUtil;
